export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14642.d121d756.jpg";